import { put, takeLatest, call } from 'redux-saga/effects';
import { httpCreators, HttpResponse, CategoryMart, Tags } from 'rbh-merchant-core';
import { MartCategoryService } from './martCategory-service';
import { MART_CATEGORY_REQUEST_ID_LIST, MART_CATEGORY_TRANSLATION_KEY, MART_TRANSLATION_KEY } from './martCategory-constant';
import { generalSagas } from '../../../../redux/general/general-saga';
import { MART_CATEGORY_STATE_KEY } from './martCategory-reducer';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { martCategoryCreators } from './martCategory-action';
import { noop } from 'lodash';
import { history } from '../../../../router';

function* callMartCategoryTnc() {
  yield put(httpCreators.request({
    service: MartCategoryService.getMartCategory,
    id: MART_CATEGORY_REQUEST_ID_LIST.GET_MART_CATEGORY,
    sagaHandler: getMartCategoryHandler as any,
  }));
  yield call(generalSagas.callTnc);
}

function* getMartTag(onSuccessCallback?: (tagMaster: Tags[]) => void) {
  yield put(httpCreators.request({
    service: MartCategoryService.getMartTag,
    id: MART_CATEGORY_REQUEST_ID_LIST.GET_MART_TAG,
    sagaHandler: getMartTagHandler as any,
    callbackParams: { onSuccessCallback }
  }));
}

function* getMartTagHandler(resp: HttpResponse, callbackParams: { onSuccessCallback: (tagMaster: Tags[]) => void }) {
  if (resp.success) {
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.TAG_LIST, resp.data.tags))
    if (callbackParams.onSuccessCallback) {
      yield call(callbackParams.onSuccessCallback, resp.data.tags);
    }
    yield call(generalSagas.callTnc);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        history.push('/main/martproduct');
      },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getMartCategoryHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.CATEGORY_LIST, resp.data.productCategories as []));
  } else {
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.CATEGORY_LIST, undefined));
  }
}

function* getMartCategoryThenTncHandler(resp: HttpResponse, callbackParams: { onSuccessCallback: (tagMaster: Tags[]) => void, onFailureCallback: () => void; }) {
  if (resp.success) {
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.CATEGORY_LIST, resp.data.productCategories as []));
    yield call(getMartTag, callbackParams.onSuccessCallback);
  } else {
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.CATEGORY_LIST, undefined));
    yield call(callbackParams.onFailureCallback);
  }
}

function* postMartCategoryHandler(resp: HttpResponse, callbackParams: { onSuccessCallback: () => void, onDismissCallback: () => void }) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
  } else if (resp.statusCode === 1899) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true, onOk: () => {
        callbackParams.onDismissCallback();
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteMartCategoryHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    // display success alert bar
    yield call(callbackParams);
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.IS_ALERT_SUCCESS, true));
  } else if (resp.statusCode === 1899) {
    if (resp.translationKey === MART_CATEGORY_TRANSLATION_KEY.PRODUCT_CATEGORY_NOT_FOUND) {
      // display generic popup
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: () => {
          callbackParams();
        },
        type: MODAL_TYPE.ERROR
      }));
    } else {
      // display error alert bar
      yield call(callbackParams);
      yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.IS_ALERT_FAILURE, true));
    }
  } else {
    // display generic popup
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getMasterMartCategoryHandler(resp: HttpResponse, callbackParams: { onSuccessCallback: () => void, onDismissCallback: () => void; }) {
  if (resp.success) {
    const productCategoryList = resp?.data.filter((productCategory: CategoryMart) => !productCategory.isAdded);
    if (productCategoryList?.length > 0) {
      yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.MASTER_DATA, resp?.data as []));
      yield call(callbackParams.onSuccessCallback);
    } else {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true, onOk: () => {
          callbackParams.onDismissCallback();
        },
        modalTitle: 'main.mart.category.error.added.title',
        modalContent: 'main.mart.category.error.added.desc',
        type: MODAL_TYPE.ERROR
      }));
    }
    yield call(generalSagas.callTnc);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getMasterTransferMartCategoryHandler(resp: HttpResponse, callbackParams: {
  currentProductCategoryId: number, onSuccessCallback: () => void
}) {
  if (resp.success) {
    const productCategoryList = resp?.data.filter((productCategory: CategoryMart) =>
      productCategory.productCategoryId !== callbackParams.currentProductCategoryId);
    yield put(martCategoryCreators.setCatState(MART_CATEGORY_STATE_KEY.MASTER_DATA, productCategoryList as []));
    yield call(callbackParams.onSuccessCallback);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postTransferMartCategoryHanlder(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else if (resp.statusCode === 1899) {
    if (resp.translationKey === MART_TRANSLATION_KEY.PRODUCT_NOT_FOUND) {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true, onOk: callbackParams,
        modalTitle: 'main.mart.category.transfer.error.notfound.title',
        modalContent: 'main.mart.category.transfer.error.notfound.desc',
        type: MODAL_TYPE.ERROR
      }));
    } else {
      yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
        visible: true,
        onOk: callbackParams,
        type: MODAL_TYPE.ERROR
      }));
    }
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

export const martCategorySagas = {
  callMartCategoryTnc,
  getMartCategoryHandler,
  getMartCategoryThenTncHandler,
  postMartCategoryHandler,
  deleteMartCategoryHandler,
  getMasterMartCategoryHandler,
  getMasterTransferMartCategoryHandler,
  postTransferMartCategoryHanlder,
  getMartTag,
  getMartTagHandler,
  watchers: [
    takeLatest(MART_CATEGORY_REQUEST_ID_LIST.CALL_MART_CATEGORY_TNC, callMartCategoryTnc)
  ]
};


